import type { RootState } from "@/store"

const selectFindMatchMode = () => (state: RootState) => state.findMatch.mode
const selectFindMatchIsSearching = () => (state: RootState) =>
  state.findMatch.isSearching

export const FindMatchSelectors = {
  selectFindMatchMode,
  selectFindMatchIsSearching
}
